import { Injectable } from '@angular/core';

declare global {
  interface Window {
    _installPromptEvent: any;
  }
}

/**
 * This service checks if the app can be installed as PWA app or not
 * and triggers installation.
 */
@Injectable({
  providedIn: 'root',
})
export class PwaService {
  promptEvent: any;

  constructor() {
    this.promptEvent = window._installPromptEvent;
  }

  install() {
    this.promptEvent.prompt();
    this.promptEvent.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
        this.promptEvent = null;
      } else {
        console.log('User dismissed the A2HS prompt');
      }
    });
  }
}
